import React from "react";
import "./style.scss"

const UnderLine = () => {
    return (
        <span className="gold-underline"></span>
    )
}

export default UnderLine